import { useState } from "react";

const AppointmentForm = () => {
  const [nume, setNume] = useState("");
  const [prenume, setPrenume] = useState("");
  const [email, setEmail] = useState("");
  const [telefon, setTelefon] = useState("");
  const [mesaj, setMesaj] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    const formData = {
      nume,
      prenume,
      email,
      telefon,
      mesaj
    };

    try {
      const res = await fetch("https://fascinating-mab-artisanstoma-04e1cb26.koyeb.app/api/programare", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      const data = await res.json();

      if (data.success) {
        setStatus("success");
        setNume("");
        setPrenume("");
        setEmail("");
        setTelefon("");
        setMesaj("");
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.log("Eroare:", error);
      setStatus("error");
    }

    setLoading(false);
  };

  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-gray-700 mb-2">Nume</label>
          <input
            type="text"
            value={nume}
            onChange={(e) => setNume(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            placeholder="Numele tău"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Prenume</label>
          <input
            type="text"
            value={prenume}
            onChange={(e) => setPrenume(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            placeholder="Prenumele tău"
            required
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-gray-700 mb-2">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            placeholder="Email-ul tău"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Telefon</label>
          <input
            type="tel"
            value={telefon}
            onChange={(e) => setTelefon(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            placeholder="Numărul tău de telefon"
            required
          />
        </div>
      </div>

      <div>
        <label className="block text-gray-700 mb-2">Mesaj</label>
        <textarea
          rows="3"
          value={mesaj}
          onChange={(e) => setMesaj(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
          placeholder="Scrie detalii despre programare..."
        ></textarea>
      </div>

      <button
        type="submit"
        disabled={loading}
        className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition"
      >
        {loading ? "Se trimite programarea... Vă rugăm să așteptați" : "Solicită Programarea"}
      </button>

      {status === "success" && (
        <p className="text-green-600 text-center mt-2">
          Programarea a fost trimisă cu succes!
        </p>
      )}

      {status === "error" && (
        <p className="text-red-600 text-center mt-2">
          A apărut o eroare. Încearcă din nou.
        </p>
      )}
    </form>
  );
};

export default AppointmentForm;